import ReactPixel from 'react-facebook-pixel';

class FbPixel{
  constructor() {

  }

  static init(){
    const advancedMatching = { }; // optional, more info: https://developers.facebook.com/docs/facebook-pixel/pixel-with-ads/conversion-tracking#advanced_match
    const options = {
        autoConfig: true, 	// set pixel's autoConfig
        debug: false, 		// enable logs
    };
    ReactPixel.init('278411032922517', advancedMatching, options);
    ReactPixel.pageView();
  }

  static addTrack(args){
    FbPixel.init();
    ReactPixel.track( args.event, args.data );
  }

  static addCustomTrack(args){
    FbPixel.init();
    ReactPixel.trackCustom( args.event, args.data );
  }
}

export default FbPixel;



// WEBPACK FOOTER //
// ./src/classes/fbPixel/FbPixel.js